module.exports = __webpack_public_path__ + "img/partner1.1fdfa9c5.png";